import React, { Component } from "react";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables-bitozen";
import LoadingBar from "react-top-loading-bar";
import PopUp from "../../../pages/PopUpAlert";
import API from "../../../../Services/Api";
import { checkResponseError } from "../../../../Services/Utils";
import { connect } from "react-redux";
import * as R from "ramda";
import { Redirect } from "react-router-dom";
import AuthAction from "../../../../Redux/AuthRedux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import SimpleDate from "../../../../modules/SimpleDate";
import M from "moment";

import FormReceivingPart from "./formReceivingItems";
import DDLCompany from "../../../../modules/commons/DDLCompany";

import Button from "../../../../modules/commons/Button";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleSearch from "../../../../modules/SimpleSearch";
import FormReceivingItems from "./formReceivingItems";
const UtilsButtonLogin = require("../../../../Services/UtilsButtonLogin");

const ct = require("../../../../modules/custom/customTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions6();

class ReceivingItems extends Component {
  constructor() {
    super();
    this.state = {
      rawData: [],
      nopenerimaan: null,
      dataTable: [
        [
          "1",
          "No Penerimaan 1",
          "No SL 1",
          "01-01-2019",
          "AJBUIEBFJN79",
          "Supplier Satu",
          "12345",
          "Fix",
        ],
        [
          "2",
          "No Penerimaan 2",
          "No SL 2",
          "02-01-2019",
          "BKJASDF8329",
          "Supplier Dua",
          "54321",
          "Fix",
        ],
        [
          "3",
          "No Penerimaan 3",
          "No SL 3",
          "03-01-2019",
          "CLKDIFJ3490",
          "Supplier Tiga",
          "67890",
          "Fix",
        ],
        [
          "4",
          "No Penerimaan 4",
          "No SL 4",
          "04-01-2019",
          "DMEIOFKG7601",
          "Supplier Empat",
          "13579",
          "Fix",
        ],
        [
          "5",
          "No Penerimaan 5",
          "No SL 5",
          "05-01-2019",
          "EJGKLSDFH982",
          "Supplier Lima",
          "24680",
          "Fix",
        ],
        [
          "6",
          "No Penerimaan 6",
          "No SL 6",
          "06-01-2019",
          "FKLSDJFOE319",
          "Supplier Enam",
          "97531",
          "Fix",
        ],
        [
          "7",
          "No Penerimaan 7",
          "No SL 7",
          "07-01-2019",
          "GLKDJFOIE324",
          "Supplier Tujuh",
          "86420",
          "Fix",
        ],
        [
          "8",
          "No Penerimaan 8",
          "No SL 8",
          "08-01-2019",
          "HDKLJFOIE43",
          "Supplier Delapan",
          "10293",
          "Fix",
        ],
        [
          "9",
          "No Penerimaan 9",
          "No SL 9",
          "09-01-2019",
          "IJFOIEWU934",
          "Supplier Sembilan",
          "38402",
          "Fix",
        ],
        [
          "10",
          "No Penerimaan 10",
          "No SL 10",
          "10-01-2019",
          "JFOIEWU349",
          "Supplier Sepuluh",
          "57689",
          "Fix",
        ],
        [
          "11",
          "No Penerimaan 11",
          "No SL 11",
          "11-01-2019",
          "KLJFOIEW43",
          "Supplier Sebelas",
          "09876",
          "Fix",
        ],
        [
          "12",
          "No Penerimaan 12",
          "No SL 12",
          "12-01-2019",
          "LJFOIEW39",
          "Supplier Dua Belas",
          "54321",
          "Fix",
        ],
        [
          "13",
          "No Penerimaan 13",
          "No SL 13",
          "13-01-2019",
          "MJFOIEW3",
          "Supplier Tiga Belas",
          "12345",
          "Fix",
        ],
        [
          "14",
          "No Penerimaan 14",
          "No SL 14",
          "14-01-2019",
          "NJFOIEW93",
          "Supplier Empat Belas",
          "24680",
          "Fix",
        ],
        [
          "15",
          "No Penerimaan 15",
          "No SL 15",
          "15-01-2019",
          "OJFOIEW09",
          "Supplier Lima Belas",
          "97531",
          "Fix",
        ],
        [
          "16",
          "No Penerimaan 16",
          "No SL 16",
          "16-01-2019",
          "PJFOIEW83",
          "Supplier Enam Belas",
          "10293",
          "Fix",
        ],
        [
          "17",
          "No Penerimaan 17",
          "No SL 17",
          "17-01-2019",
          "QJFOIEW73",
          "Supplier Tujuh Belas",
          "38402",
          "Fix",
        ],
        [
          "18",
          "No Penerimaan 18",
          "No SL 18",
          "18-01-2019",
          "RJFOIEW09",
          "Supplier Delapan Belas",
          "57689",
          "Fix",
        ],
        [
          "19",
          "No Penerimaan 19",
          "No SL 19",
          "19-01-2019",
          "SJFOIEW04",
          "Supplier Sembilan Belas",
          "09876",
          "Fix",
        ],
        [
          "20",
          "No Penerimaan 20",
          "No SL 20",
          "20-01-2019",
          "TJFOIEW38",
          "Supplier Dua Puluh",
          "12345",
          "Fix",
        ],
        [
          "21",
          "No Penerimaan 21",
          "No SL 21",
          "21-01-2019",
          "UJFOIEW93",
          "Supplier Dua Puluh Satu",
          "54321",
          "Fix",
        ],
      ],
      selectedIndex: [],
      createVisible: false,
      updateVisible: false,
      deletePopUpVisible: false,
      savePopUpVisible: false,
      loadSave: false,
      allowResize: false,
      defaultSize: 0,
      minSize: 0,
      maxSize: 0,
      timeout: 1000 * 100 * 9,
      isTimedOut: false,
      toCount: 0,
      table_limit: 10,
      table_page: 0,
      table_query: "",
      createVisible2: false,
      tabIndex: 0,
      checkTab: false,
      data: {},
      dataDto: {},
      buttonAccess: {},
    };
    this.idleTimer = null;
  }

  logout() {
    this.props.authLogout();
    return <Redirect to={{ pathname: "/" }} />;
  }

  onAction() {
    this.setState({ isTimedOut: false });
  }

  onActive() {
    this.setState({ isTimedOut: false });
  }

  onIdle() {
    const isTimedOut = this.state.isTimedOut;
    if (isTimedOut) {
      alert("Your session has timed out. Please log in again");
      this.logout();
    } else {
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  }

  onChangeDate = (e, name) => {
    this.setState({
      data: {
        ...this.state.data,
        [name]: M(e).format("DD-MM-YYYY"),
      },
    });
  };

  componentDidMount() {
    UtilsButtonLogin.buttonAccess("MASTER-022", (response) => {
      // console.log("ORI ", response);
      this.setState(
        {
          buttonAccess: response,
        },
        () => {
          this.getCountPage(this.state.table_page, this.state.table_limit);
        }
      );
    });
  }

  getCountPage = async (page, limit) => {
    console.log("hitApiGet");
    let payload = {
      limit: limit,
      offset: page,
      // filter: this.state.table_query,
      // companyId: this.state.dataDto.companyId,
      // companyGroupId: null,
      // category: null,
      // isActive: null,
      // sortBy: this.state.dataDto.sortBy ?? "",
      // orderBy: this.state.dataDto.orderBy ?? "",
    };

    let res = await API.create("LOCAL_RECEIVINGPART").getPart(payload);
    if (res.ok) {
      console.log("dataBalikan", res.data.data);
      if (res.data.data === null) {
        this.setState({ dataTable: [] });
      } else {
        // console.log(JSON.stringify(res.data.data, null, 2));
        let dataTable =
          res.data.data &&
          res.data.data.map((value) => {
            const {
              namasupplier,
              noid,
              noinvoice,
              nopenerima,
              nopo,
              noship,
              tglterima,
              type,
            } = value;
            return [
              namasupplier,
              noid,
              noinvoice,
              nopenerima,
              nopo,
              noship,
              tglterima,
              type,
            ];
          });
        console.log("datatable", +dataTable);
        this.setState({
          rawData: res.data.data && res.data.data.listUser,
          dataTable,
          toCount: res.data.data && res.data.data.dataOfRecord,
        });
        this.onFinishFetch();
      }
    }
  };

  handleClearUser = (e) => {
    this.setState(
      {
        table_page: 0,
        toCount: 0,
        data: {},
        dataDto: {},
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  handleSearch = (eventSearch) => {
    this.setState(
      {
        table_page: 0,
        dataDto: eventSearch ? this.state.data : this.state.dataDto,
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  isLoad(visible) {
    this.setState({ loadSave: visible });
  }

  checkResponse(res, type) {
    if (res.ok && res.data.status === "S") {
      type === "delete" && this.setState({ deletePopUpVisible: false });
      setTimeout(() => {
        this.openSavePopUp();
      }, 500);
    } else {
      this.isLoad(false);
      checkResponseError(res);
    }
  }

  handleSubmit = async (response) => {
    this.checkResponse(response);
  };

  handleDelete = async () => {
    this.isLoad(true);
    let payload = { ...this.state.rawData[this.state.selectedIndex] };
    payload.action = "DELETE";

    let response = await API.create("MASTERDATA_EKSAD").postSaveUser(payload);
    this.checkResponse(response, "delete");
    this.isLoad(false);
  };

  handlePopUp = () => {
    this.handleSearch();
    this.setState({
      savePopUpVisible: false,
      createVisible: false,
      createVisible2: false,
    });
  };

  onchangeInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
    });
  };

  startFetch = () => {
    this.LoadingBar.continousStart();
  };

  onFinishFetch = () => {
    if (typeof this.LoadingBar === "object") this.LoadingBar.complete();
  };

  openCreateForm = () => {
    this.setState({ createVisible: !this.state.createVisible });
  };

  openUpdateForm = () => {
    this.setState({ updateVisible: !this.state.updateVisible });
  };

  openSavePopUp = () => {
    this.setState({
      savePopUpVisible: !this.state.savePopUpVisible,
      loadSave: false,
    });
  };

  openDeletePopup = (index) => {
    this.setState({
      deletePopUpVisible: !this.state.deletePopUpVisible,
      selectedIndex: index,
    });
  };

  columnsUser = [
    { name: "No." },
    { name: "No. Penerimaan" },
    { name: "No. Shipping" },
    { name: "Tanggal Terima" },
    { name: "No. Invoice" },
    { name: "Nama Supplier" },
    { name: "No. PO" },
    { name: "Type" },
    {
      name: "Receive",
      options: {
        customBodyRender: (val, tableMeta) => {
          return (
            <div style={{ width: "115px" }}>
              <Button
                className="btnRun"
                style={{ marginRight: 15, backgroundColor: "transparent" }}
                onClick={this.opSidePage}
                permission=""
              >
                <i
                  className="fas fa-running"
                  style={{
                    backgroundColor: "transparent",
                    color: "red",
                    fontSize: 25,
                  }}
                />
              </Button>
            </div>
          );
        },
      },
    },
  ];

  opSidePage = (menu, data) => (e) => {
    e.preventDefault();
    let selectedIndex = data;
    this.setState({
      updateVisible: false,
    });

    switch (menu) {
      case "slide-menu-1":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "update",
        });
        break;
      case "slide-menu-view":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "view",
        });
        break;
      default:
        break;
    }
  };
  resetTab = (tabIndex) => {
    this.setState({ tabIndex });
    if (tabIndex === 0) {
      this.getCountPage(this.state.table_page, this.state.table_limit);
    }
  };

  render() {
    if (R.isNil(this.props.auth.user))
      return <Redirect to={{ pathname: "/" }} />;
    let { toCount, table_query } = this.state;
    let tableOptions = {
      ...options,
      //serverSide: true,
      filter: false,
      count: toCount,
      selectableRowsHeader: true,
      searchText: table_query,
      search: false,
      viewColumns: false,
      rowsPerPage: this.state.table_limit,
      page: this.state.table_page,
      onColumnSortChange: (changedColumn, direction) => {
        let order = "desc";
        if (direction === "ascending") {
          order = "asc";
        }

        let columnOrder = "";

        if (changedColumn === "Company") {
          columnOrder = "companyCode";
        }

        if (changedColumn === "Username") {
          columnOrder = "username";
        }

        if (changedColumn === "Email") {
          columnOrder = "email";
        }

        if (changedColumn === "Category") {
          columnOrder = "category";
        }

        if (changedColumn === "Employee Name") {
          columnOrder = "name";
        }

        if (changedColumn === "Status") {
          columnOrder = "status";
        }

        this.columnsUser.map((value, index) => {
          if (changedColumn === value.name && value.name !== "Action") {
            value.options = { sortDirection: order };
          } else {
            value.options = { ...value.options, sortDirection: "none" };
          }
        });

        this.setState(
          {
            dataDto: {
              ...this.state.dataDto,
              sortBy: columnOrder,
              orderBy: order,
            },
          },
          () => {
            this.getCountPage(this.state.table_page, this.state.table_limit);
          }
        );
      },
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.setState({ table_page: tableState.page });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.setState({ table_limit: tableState.rowsPerPage });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "search":
            let searchText = tableState.searchText ? tableState.searchText : "";
            this.setState({ table_query: searchText }, () => {
              this.handleSearch();
            });
            break;
          default:
            break;
        }
      },
    };
    return (
      <div className="main-slider">
        <div className="padding-tbl-monitoring">
          <LoadingBar onRef={(ref) => (this.LoadingBar = ref)} />
          <Tabs
            selectedIndex={this.state.tabIndex}
            onSelect={(tabIndex) => this.resetTab(tabIndex)}
          >
            <TabList>
              <Tab>Receiving Items</Tab>
            </TabList>
            <TabPanel>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                   <div style={{ marginTop: "5px", marginRight: "10px" }}>
                   <Button
                      type="button"
                      style={{ width: "130px", height: "40px" }}
                      className="btn btn-plus background-red margin-left-15px"
                      valueCombo={this.state.data.companyIdSelect}
                      onClick={this.openCreateForm.bind(this)}
                    >
                      <span>
                        <i
                          className="fa fa-plus"
                          style={{ marginRight: "10px" }}
                        />
                        TAMBAH
                      </span>
                    </Button>
                   </div>
                <div style={{ display: "flex" }}>
                  <SimpleDate
                    date={this.state.data.startDate}
                    minDate={new Date()}
                    backdate
                    onChange={(date) => this.onChangeDate(date, "startDate")}
                  />
                </div>
                <div style={{ display: "flex", marginLeft: "670px" }}>
                      <div>
                      <SimpleSearch
                        name="noka"
                        // readOnly={this.props.type !== "create"}
                        value={this.state.data.noka}
                        onChange={this.onchangeInput}
                      />
                    </div>
                    <div style={{ marginTop: "3px", marginLeft: "20px" }}>
                      <Button
                        type="button"
                        style={{ width: "50px" }}
                        className="btn btn-plus background-red "
                        valueCombo={this.state.data.companyIdSelect}
                        onClick={this.openCreateForm.bind(this)}
                      >
                        <span>
                          <i className="fa fa-qrcode" />
                        </span>
                      </Button>
                    </div>
                  </div>
              </div>
              <div>
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    key={toCount}
                    title={"Items List"}
                    subtitle={"Setting data of Items List"}
                    data={this.state.dataTable}
                    columns={this.columnsUser}
                    options={tableOptions}
                    buttonCreate={this.state.buttonAccess.btnAdd}
                    onCreate={this.openCreateForm.bind(this)}
                  />
                </MuiThemeProvider>
              </div>
            </TabPanel>
          </Tabs>
        </div>

        <div>
          {this.state.createVisible && (
            <FormReceivingItems
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.updateVisible && (
            <FormReceivingItems
              type={this.state.popupType === "update" ? "edit" : "view"}
              data={this.state.rawData[this.state.selectedIndex]}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openUpdateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.savePopUpVisible && (
            <PopUp
              type={"save"}
              class={"app-popup app-popup-show"}
              onClick={this.handlePopUp.bind(this)}
            />
          )}

          {this.state.deletePopUpVisible && (
            <PopUp
              type={"delete"}
              class={"app-popup app-popup-show"}
              onClickDelete={this.handleDelete}
              onClick={this.openDeletePopup}
              isLoading={this.state.loadSave}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    h3Module: state.h3Module,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authLogout: () => dispatch(AuthAction.authLogout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReceivingItems);
